<div class="section-header">
    <div class="d-flex">
        <div class="w-100">
            <div class="container">
                <span class="h2">Risultati per: <strong>{{ ricerca }}</strong></span><br>
            </div>
        </div>
    </div>
</div>


<div class="row"><hr></div>



<div class="wrapper">
        <div class="container d-flex justify-content-between align-items-start">
            <div class="nav-tabs-navigation pt-0 w-100" data-tabs-color="orange">
                <div class="nb-theme-default">
                    <nb-tabset id="tabset-docs" fullWidth>
                        <nb-tab [tabTitle]="'Articoli (' + totaleRisultatiNews + ')'" style="overflow:hidden">
                            <div class="container d-flex justify-content-center">
                                <div class="container p-3">
                                    <div class="d-flex justify-content-center p-2"><div class="d-flex">Corrispondenze trovate: {{totaleRisultatiNews}}</div></div>
                                    <div class="row" *ngFor="let element of resultList; let i = index">
                                        
                                        <div class="col-12 ">
                                            <div class="d-flex gap-3 align-items-start p-3 mb-3 border rounded shadow-sm news-card"
                                                (click)="findById(element.idArticolo)" style="cursor: pointer;">
                                                <div style="width: 120px; flex-shrink: 0;">
                                                    <img [src]="getImageSrcById(element.imgId)" alt="{{ element.titolo }}" class="img-fluid rounded"
                                                        style="object-fit: cover; aspect-ratio: 1/1;" />
                                                </div>
                                
                                                <div class="flex-grow-1 pl-3">
                                                    <h5 class="mb-1">{{ element.titolo }}</h5>
                                                    <div class="text-muted mb-2" style="font-size: 0.9em;">
                                                        <em>Data:</em> {{ element.dataInserimento | date: 'dd/MM/yyyy' }}
                                                    </div>
                                                    <p class="preview-text m-0">{{ getAnteprimaTesto(element.corpo, 350) }}</p>
                                                    <!-- <div class="preview-text" [innerHTML]="element.corpo"></div> -->
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                
                                    <div class="w-100 d-flex justify-content-center px-5">
                                        <button *ngIf="totaleRisultatiNews > resultList.length && totaleRisultatiNews != 0" (click)="moreNews()"
                                            class="btn btn-info" style="padding-top: 10px; padding-bottom: 10px; cursor:pointer;">Carica più risultati
                                        </button>
                                    </div>
                                
                                </div>
                            </div>
                        </nb-tab>

                        <nb-tab [tabTitle]="'Documenti (' + totaleRisultatiDocs + ')'" style="overflow:hidden">
                            <div class="container d-flex justify-content-center">
                                <div class="container p-3">
                                    <div class="d-flex justify-content-center p-2"><div class="d-flex">Corrispondenze trovate: {{totaleRisultatiDocs}}</div></div>
                                    <div class="row" *ngFor="let element of resultListDocs; let i = index">
                                        <div class="col-12 ">
                                            <div class="d-flex gap-3 align-items-start p-3 mb-3 border rounded shadow-sm news-card"
                                            (click)="linkToDoc(element.url)"
                                            style="cursor: pointer;">
                                                <div class="pdf-icon" >
                                                    <i class="far fa-file-pdf"></i>
                                                </div>
                                                <div class="flex-grow-1 pl-3">
                                
                                                    <h5 class="mb-1">{{ element.descrizione }}</h5>
                                                    <div class="text-muted mb-2" style="font-size: 0.9em;">
                                                        <span>Sezione: {{ sezioneById[element.idSezione]?.title || 'Sezione sconosciuta' }}</span><br>
                                                        <span>Categoria: {{ categoriaById[element.idCategoria]?.title || 'Categoria sconosciuta'
                                                            }}</span>
                                
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                
                                    <div class="w-100 d-flex justify-content-center px-5">
                                        <button *ngIf="totaleRisultatiDocs > resultListDocs.length && totaleRisultatiDocs != 0" (click)="moreDocs()"
                                            class="btn btn-info" style="padding-top: 10px; padding-bottom: 10px; cursor:pointer;">
                                            Carica più risultati
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </nb-tab>


                    </nb-tabset>
                </div>
            </div>
        </div>
</div>